<script>
    import {link} from 'svelte-spa-router'
    import {logOut} from '../../js-core/conn/auth/auth-main'
    export let vis = {
        home: true,
        campaigns: false,
        tvSpot: false
    }
    function handleClick(pageToNavTo) {
        for(var key in vis) {
            vis[key] = false;
        }
        vis[pageToNavTo] = true;
    }
</script>
<style>
</style>
<div class="Header">
    <img src="static/logos/BriteSignalJustLogo.png" alt="brite signal logo">
    <div class="Page_Title Home__Class">
        <a href="/advertiser" use:link>Home</a>
    </div>
    <div class="Page_Title Campaigns_Class">
        <a href="/advertiser/campaigns" use:link>Campaigns</a>
    </div>
    <!-- <div class="Page_Title TV_Spots_Class">
        <a href="/advertiser/tv-spots" use:link>TV Spots</a>
    </div> -->
    <button class="Page_Title Log_Out_Box main" on:click={logOut}>
        <div class="Log_Out_Text">
            <span>Log Out</span>
        </div>
    </button>
</div>